/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FundamentalDomainDTO,
    FundamentalDomainDTOFromJSON,
    FundamentalDomainDTOFromJSONTyped,
    FundamentalDomainDTOToJSON,
} from './FundamentalDomainDTO';

/**
 * 
 * @export
 * @interface FundamentalDomainDTOPagedResponse
 */
export interface FundamentalDomainDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof FundamentalDomainDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FundamentalDomainDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof FundamentalDomainDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FundamentalDomainDTO>}
     * @memberof FundamentalDomainDTOPagedResponse
     */
    data?: Array<FundamentalDomainDTO> | null;
}

export function FundamentalDomainDTOPagedResponseFromJSON(json: any): FundamentalDomainDTOPagedResponse {
    return FundamentalDomainDTOPagedResponseFromJSONTyped(json, false);
}

export function FundamentalDomainDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundamentalDomainDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(FundamentalDomainDTOFromJSON)),
    };
}

export function FundamentalDomainDTOPagedResponseToJSON(value?: FundamentalDomainDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(FundamentalDomainDTOToJSON)),
    };
}

